import React from "react";
import "./styles.css";

const PowerBiLayout = ({ children }) => {
  return <div className="page-content-powerbi">{children}</div>;
};

export default PowerBiLayout;
